export {MetadataWriterHost, TsickleHost} from './src/compiler_host';
export {CodegenExtension, main} from './src/main';

export {default as AngularCompilerOptions} from './src/options';
export * from './src/cli_options';
export * from './src/collector';
export * from './src/schema';
